import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Deterministic 32-bit hash z node_id (UUID string).
 * KB SRO 1.1: source_context propagation = same hash logic across pipeline.
 * KB 4.1: enables strukturalna unikalnosc per node bez randomness.
 * Pure JS (djb2) — dziala w Node, Vite SSR, edge runtime, browser. Zero deps.
 */
export function hashNodeId(nodeId: string): number {
  let hash = 5381;
  for (let i = 0; i < nodeId.length; i++) {
    hash = ((hash << 5) + hash) + nodeId.charCodeAt(i); // hash * 33 + c
    hash = hash >>> 0; // force 32-bit unsigned
  }
  return hash;
}

/** Pick deterministic per nodeId. dimensionShift>0 daje independent picker dimensions. */
export function pickFromList<T>(nodeId: string, list: T[], dimensionShift = 0): T {
  if (list.length === 0) throw new Error("pickFromList: empty list");
  const hash = hashNodeId(nodeId);
  const shifted = dimensionShift > 0 ? hash >>> dimensionShift : hash;
  return list[shifted % list.length];
}
